import layout from 'layouts/default'
import tabs from '../tabs'
import { dateFormat, currencySymbol } from 'filters'
import pagination from 'components/pagination'
import { reservationDetails } from 'components/modals'
import { hasPermits } from 'directives'
import datepicker from 'components/datepicker'
import sSelect from 'components/sSelect'
import moment from 'moment'
import timepicker from 'components/timepicker'
import { permits } from 'services'

const directives = {
  hasPermits
}

const components = {
  layout,
  tabs,
  pagination,
  reservationDetails,
  datepicker,
  sSelect,
  timepicker
}

const filters = {
  dateFormat,
  currencySymbol
}

const computed = {
  location () {
    return _.cloneDeep(this.$store.state.locations.active);
  },
  reservations () {
    return _.cloneDeep(this.$store.state.locations.active.reservations);
  },
  currencyCode() {
    return this.location.currency ? currencySymbol(this.location.currency.code) : "Na";
  }
}

const methods = {
  loadPage (page) {
    this.errors = {};
    this.$route.query.page = page;
    this.loading = true;
    let params = {
      page,
      _sort: '-id',
      search_by: this.filters.search_by,
      'reservation_number-lk': this.filters.search ? (this.filters.search_by == 'reservation_number' ? "*" + this.filters.search.trim() + "*" : this.filters.search.trim()): null,
      cancelled: this.filters.cancelled,
      type: this.filters.type
    }

    if (this.show_advanced_search) {
      if (this.filters.from_date) {
        if (moment(this.filters.from_date).isValid() && this.filters.from_time) {
          params.from_date = moment(`${this.filters.from_date} ${this.filters.from_time}`).format('YYYY-MM-DD HH:mm:ss');
        } else {
          params.from_date = moment(this.filters.from_date, ['MM/DD/YYYY']).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        }
      }
      if (this.filters.to_date) {
        if (moment(this.filters.to_date).isValid() && this.filters.to_time) {
          params.to_date = moment(`${this.filters.to_date} ${this.filters.to_time}`).format('YYYY-MM-DD HH:mm:ss');
        } else {
          params.to_date = moment(this.filters.to_date, ['MM/DD/YYYY']).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        }
      }
      if (this.selectedTypes.length) {
        params.parking_types = this.selectedTypes.filter(type => type.value.includes('parking')).map((type) => {
          return Number(type.value.replace('parking-', ''));
        });
        params.room_types = this.selectedTypes.filter(type => type.value.includes('room')).map((type) => {
          return Number(type.value.replace('room-', ''));
        });
        params.bundle_types = this.selectedTypes.filter(type => type.value.includes('bundle')).map((type) => {
          return Number(type.value.replace('bundle-', ''));
        });
      }
    }

    Promise.all([
      this.$store.dispatch('locations.get', {id: this.$route.params.id}),
      this.$store.dispatch('locations.getReservations', {
        id: this.$route.params.id,
        params: params
      })
    ]).then(() => {
      this.loading = false;
      let errors = _.cloneDeep(this.$store.state.locations.errors);
      if (errors) {
        this.errors = errors.errors;
      }
    });
  },
  loadReservation (item) {
    this.$set(this.loadings, item.id, true);
    this.$store.dispatch('locations.getReservation', {
      id: item.id,
      lId: this.$route.params.id
    }).then(() => {
      this.$set(this.loadings, item.id, false);
      this.activeReservation = this.$store.state.locations.active_reservation;
      this.$refs.reservationDetailsModal.open();
    })
  },

  onChangeSelectedTypes (types) {
    this.selectedTypes = types;
  },
}

const watch = {
  activeTab (n) {
    if (n.title == "Reservations") {
      this.loadPage(1);
    }
  },

  show_advanced_search (n, o) {
    if (n == o) return;
    if (n == false) {
      this.filters.from_date =  null;
      this.filters.from_time = null;
      this.filters.to_date = null;
      this.filters.to_time = null;
      this.selectedTypes = [];
    }
  }
}

export default {
  name: 'reservations-tab',
  props: ['activeTab'],
  directives,
  components,
  computed,
  methods,
  filters,
  watch,
  data () {
    return {
      loading: false,
      activeReservation: null,
      loadings: {},
      show_advanced_search: false,
      have_advanced_search_permission: false,
      filters: {
        search: null,
        search_by: 'reservation_number',
        cancelled: null,
        type: null,
        from_date: null,
        from_time: null,
        to_date: null,
        to_time: null,
      },
      locationTypes: [],
      parkingTypes: [],
      roomTypes: [],
      bundleTypes: [],
      selectedTypes: [],
      errors: {},
    }
  },
  created () {
    if (permits.hasPermit('reservations_advanced_search') || permits.hasLocationPermit(this.$route.params.id, ['reservations_advanced_search'])) {
      this.have_advanced_search_permission = true;
    }

    this.loadPage(1);
    let promises = [
      this.$store.dispatch('locations.parkingTypes', {id: this.$route.params.id}),
      this.$store.dispatch('locations.roomTypes', {id: this.$route.params.id}),
      this.$store.dispatch('locations.bundleTypes', {id: this.$route.params.id}),
    ];

    Promise.all(promises).then(() => {
      let parking_types = _.cloneDeep(this.$store.state.locations.active.parkingTypes);
      let room_types = _.cloneDeep(this.$store.state.locations.active.roomTypes);
      let bundle_types = _.cloneDeep(this.$store.state.locations.active.bundleTypes);
      let location_types = [];

      parking_types.forEach((item) => {
        location_types.push({type: 'parking', item: item});
      });
      room_types.forEach((item) => {
        location_types.push({type: 'room', item: item});
      });
      bundle_types.forEach((item) => {
        location_types.push({type: 'bundle', item: item});
      });

      this.locationTypes = _.map(location_types, item => {
        return {
          value: item.type + '-' + item.item.id,
          text: item.item.name
        }
      });
    });
  }
}
